import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import validation from "../../components/landingHeader/validation";
import { InputField } from "../../components/InputField/InputField";
import { ErrorMessage } from "@hookform/error-message";
import Services from "../../API/services";
import LandingHeader from "../../components/landingHeader";
import FrontFooter from "../../layout/footer/FrontFooter";
import { Imagesdata } from "../../assets/images/imageData";

const PropertyInquery = () => {

    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);

    const { AlertIcon } = Imagesdata || {};
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const {
        register,
        handleSubmit,
        reset,
        control,
        watch,
        formState: { errors },
    } = useForm({ ...validation, mode: "onSubmit" });

    const onSubmit = async (payload) => {
        const realPayload = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            email: payload.email,
            mobile: payload?.phoneNumber.toString(),
            property_name: payload.propertyName,
            address_line_1: payload.address,
            address_line_2: payload.addressLine,
            state_id: payload.state,
            city: payload.city,
            pincode: payload.postalCode,
        };
        try {
            const res = await Services.property.createEnquiryService(realPayload);
            if (res.status === 201) {
                toast.success("Thank you! We've received your inquiry. Our team will contact you soon.", {
                    autoClose: 1000,
                    pauseOnHover: true,
                    position: "center",
                });
                reset();
                navigate('/')
            }
        } catch (error) { }
    };

    const getState = async () => {
        try {
            const state = await Services.globalService.getAllState();
            if (state.status === 200) {
                setStateList(state.data.data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        getState();
    }, []);
    const getCity = async (id) => {
        try {
            const state = await Services.globalService.getAllCitiesByState(id);
            if (state.status === 200) {
                setCityList(state.data.data);
            }
        } catch (error) { }
    };
    const { state } = watch();

    useEffect(() => {
        if (state) {
            getCity(state);
        }
    }, [state]);

    return (
        <>
            <LandingHeader />
            <div className='property-enquiry-form'>
                <div className='custom-wrapper'>
                    <div className='bg-white p-4'>
                        <h3 className='pb-4'>Property Enquiry</h3>
                        <Form
                            className="popup-form frontFormAddMember"
                            onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col xs={12} className="form-group">
                                    <InputField
                                        htmlFor="propertyName"
                                        text="Property Name"
                                        type="text"
                                        placeholder="Enter Property Name"
                                        field={"propertyName"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.propertyName?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"propertyName"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>

                                <Col xs={6} className="form-group">
                                    <InputField
                                        htmlFor="firstName"
                                        text="First Name"
                                        type="text"
                                        autoFocus={true}
                                        placeholder="Enter first name"
                                        field={"firstName"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.firstName?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"firstName"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col xs={6} className="form-group">
                                    <InputField
                                        htmlFor="lastName"
                                        text="Last Name"
                                        type="text"
                                        placeholder="Enter Last name"
                                        field={"lastName"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.lastName?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"lastName"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col xs={6} className="form-group">
                                    <InputField
                                        htmlFor="phoneNumber"
                                        text="Phone No."
                                        type="text"
                                        max={10}
                                        placeholder="Enter phone number"
                                        field={"phoneNumber"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.phoneNumber?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"phoneNumber"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col xs={6} className="form-group">
                                    <InputField
                                        htmlFor="email"
                                        text="Email address "
                                        type="email"
                                        placeholder="Enter email address"
                                        field={"email"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.email?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"email"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col xs={12} className="form-group">
                                    <InputField
                                        htmlFor="address"
                                        text="Property Address"
                                        type="text"
                                        placeholder="Enter property address Line 1"
                                        field={"address"}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.address?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"address"} />
                                            </span>
                                        </div>
                                    )}
                                    <br />
                                    <InputField
                                        htmlFor="addressLine"
                                        text=""
                                        type="text"
                                        placeholder="Enter property address Line 2"
                                        field={"addressLine"}
                                        register={register}
                                        errors={errors}
                                    />
                                </Col>
                                <Col xs={4} className="form-group">
                                    <label className="label form-label">State</label>
                                    <Controller
                                        control={control}
                                        {...register("state")}
                                        name={"state"}
                                        render={({ field: { onChange, value } }) => (
                                            <select
                                                onChange={onChange}
                                                value={value}
                                                className="form-control"
                                            >
                                                <option selected disabled>
                                                    Select State
                                                </option>
                                                {stateList?.map((data, key) => (
                                                    <option key={key} value={data.id}>
                                                        {data.name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                </Col>
                                <Col xs={4} className="form-group">
                                    <label className="label form-label">City</label>
                                    <Controller
                                        control={control}
                                        name={"city"}
                                        render={({ field: { onChange, value, ref } }) => (
                                            <select
                                                onChange={onChange}
                                                value={value}
                                                className="form-control"
                                            >
                                                <option selected disabled>
                                                    Select City
                                                </option>
                                                {cityList.map((data, key) => (
                                                    <option key={key} value={data.id}>
                                                        {data.name}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                    {errors?.city?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"city"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col xs={4} className="form-group">
                                    <InputField
                                        htmlFor="postalCode"
                                        text="Postal Code"
                                        type="text"
                                        placeholder="Enter Postal Code"
                                        field={"postalCode"}
                                        max={6}
                                        register={register}
                                        errors={errors}
                                    />
                                    {errors?.postalCode?.message && (
                                        <div className="error-text">
                                            <img alt="" src={AlertIcon} />
                                            <span>
                                                <ErrorMessage errors={errors} name={"postalCode"} />
                                            </span>
                                        </div>
                                    )}
                                </Col>

                                <Col xs={12} className="form-group text-right mt-2">
                                    <Button variant="primary" size="md" type="submit">
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </>
    )
}

export default PropertyInquery